import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Constants } from "../data/constants";

@Injectable({
  providedIn: "root",
})
export class RecaptchaService {
  constructor(private http: HttpClient) {}

  validateCaptcha(captchaResponse: string): Observable<boolean> {
    return this.http.post<boolean>(
      `${environment.APP_PORT + Constants.RECAPTCHA}`,
      captchaResponse
    );
  }
}
